import CustomDayScheduleSelector from "./CustomDayScheduleSelector";

const CustomWeeklyScheduleSelector = ({ register, config, errors, isLoading }) => {
    const days = {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
    };

    return (
        <>
            {config.title && (
                <h3 className={`text-primary text-xl mt-2 ${config.className}`}>{config.title}</h3>
            )}

            <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-7 gap-3">
                {Object.keys(days).map((day) => (
                    <CustomDayScheduleSelector
                        key={day}
                        customKey={day}
                        register={register}
                        config={{
                            ...config,
                            label: days[day],
                            name: day,
                        }}
                        errors={errors}
                        isLoading={isLoading}
                    />
                ))}
            </div>
        </>
    );
};

export default CustomWeeklyScheduleSelector;
